module.exports = __webpack_public_path__ + "img/ctrl-glu.eb15b54b.png";